import { type ReactNode, Suspense } from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Provider } from "react-redux";
import { theme } from "~/app/theme";
import { ThemeProvider } from "~/common/mui";
import { getStore } from "~/app/store/getStore";

window.SCHA = window.SCHA || {};
window.SCHA.cmps = {};

const tryCreate = (componentName: string, rootElement: HTMLElement, props: unknown) => {
  const factory = window.SCHA.cmps[componentName];
  if (factory) {
    try {
      render(renderRoot(factory(props)), rootElement);
    } catch (e) {
      if (e instanceof Error) {
        console.error(`Error when rendering component at ${rootElement.id}: ${e.message}`);
        console.error(e.stack);
      }
    }
  } else {
    console.error(`Could not find a component registered as ${componentName}`);
  }
};
window.SCHA.createComponentInElement = tryCreate;

window.SCHA.unmountComponentAtNode = unmountComponentAtNode;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerComponentFactory(name: string, factory: (props: any) => ReactNode) {
  if (import.meta.env.DEV) {
    if (window.SCHA.cmps[name]) {
      console.warn(`Component registry: Overriding an already registered component at ${name}`);
    }
  }

  window.SCHA.cmps[name] = factory;
}

const renderRoot = (node: ReactNode) => {
  return (
    <Suspense fallback={null}>
      <ThemeProvider theme={theme}>
        <Provider store={getStore()}>{node}</Provider>
      </ThemeProvider>
    </Suspense>
  );
};
